function preloadImage(image) {
	image.src = image.dataset.src;

	if(image.dataset.srcset) {
		image.srcset = image.dataset.srcset;
	}
}

function seatsLazyloadImages( element ) {
	var images = element.querySelectorAll('.lazyload');
	var config = {
		rootMargin: '50px 0px',
		threshold: 0.01
	};

	if (!('IntersectionObserver' in window)) {
		// Load images
		Array.prototype.forEach.call(images, function (image) {
			preloadImage(image)
		});
	} else {
		// Lazy load images
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				// Are we in viewport?
				if (entry.intersectionRatio > 0) {
					// Stop watching and load the image
					observer.unobserve(entry.target);
					preloadImage(entry.target);
				}
			});
		}, config);

		images.forEach(function (image) {
			observer.observe(image);
		});
	}
}

seatsLazyloadImages(document);
window.seatsLazyloadImages = seatsLazyloadImages;


